import { Compass, ListChecks, Map, Route, TrendingUp, ArrowUpRight } from "lucide-react";
import { SITE } from "@/constants/site";
import { Reveal } from "@/components/Reveal";
import { SectionTag } from "@/components/SectionTag";
import { useLang } from "@/i18n/LangContext";

const ICONS = [Compass, ListChecks, Route, Map, TrendingUp];

export const Positioning = () => {
  const { t } = useLang();
  const p = t.home.positioning;
  return (
  <section className="px-5 md:px-10 py-24 md:py-32 bg-white" data-testid="positioning">
    <div className="mx-auto max-w-7xl">
      <div className="grid gap-12 lg:grid-cols-[1fr_1.4fr] lg:gap-20">
        <div>
          <SectionTag>{p.tag}</SectionTag>
          <Reveal delay={0.1}>
            <h2 className="mt-5 font-display text-3xl md:text-5xl font-bold tracking-tight text-balance">
              {p.h2}
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="mt-6 font-display text-xl md:text-2xl font-bold tracking-tight text-terracotta-deep">
              {p.bold}
            </p>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-4 text-base md:text-lg leading-relaxed text-plum/80">
              {p.promise}
            </p>
          </Reveal>
          <Reveal delay={0.25} className="mt-8">
            <a
              href={SITE.calendly}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="positioning-cta-rdv"
              className="group inline-flex items-center gap-2.5 rounded-full bg-terracotta px-7 py-4 text-sm font-semibold text-ink transition-colors duration-300 hover:bg-terracotta-dark"
            >
              {p.cta}
              <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
          </Reveal>
        </div>
        <div className="grid gap-4 sm:grid-cols-2">
          {p.pillars.map((pillar, i) => {
            const Icon = ICONS[i];
            return (
            <Reveal
              key={pillar.title}
              delay={i * 0.08}
              className={i === 0 ? "sm:col-span-2" : ""}
            >
              <div className="group h-full rounded-3xl border border-ink/5 bg-cream/60 p-7 transition-all duration-500 hover:bg-cream hover:shadow-[0_20px_40px_-15px_rgba(17,14,13,0.1)]">
                <Icon className="w-6 h-6 text-terracotta-deep" strokeWidth={1.75} aria-hidden="true" />
                <h3 className="mt-4 font-display text-lg font-bold tracking-tight">{pillar.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-plum/75">{pillar.text}</p>
              </div>
            </Reveal>
            );
          })}
        </div>
      </div>
    </div>
  </section>
  );
};
